export const AdminCancelType = 1